import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles((theme) => ({
  tooltip: theme.tooltip,
}));
